import { useMemo } from 'react';

import { Button } from '@kanda-libs/ks-design-library';

import DeclineQuoteModal from './DeclineQuoteModal';
import useDeclineQuote from './useDeclineQuote';

export interface DeclineQuoteButtonProps {
  singleButton: boolean;
}

const DeclineQuoteButton: React.FunctionComponent<DeclineQuoteButtonProps> =
  function ({ singleButton = false }) {
    const { isLoading, onClick } = useDeclineQuote();
    const className = useMemo(
      () =>
        [
          'hover:bg-neutral-100 rounded-full',
          singleButton ? 'col-span-2 ' : 'col-span-1 md:col-span-2 ',
        ].join(' '),
      [singleButton],
    );
    return (
      <>
        <Button.Text
          id="decline-quote"
          variant="ghost"
          className={className}
          onClick={onClick}
          label={
            <p className="text-14-22-em text-red-200 -mx-6">Decline Quote</p>
          }
          isLoading={isLoading}
        />
        <DeclineQuoteModal />
      </>
    );
  };

export default DeclineQuoteButton;
